export default function Error500() {
  return (
    <div className="error-container">
      <h1 class="oneline">Что-то пошло не так</h1>

      <div className="error-container__buttons">
        <a href="/admin" className="btn btn--dark">На главную</a>
      </div>
    </div>
  );
};
